<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :toolbar-config="tableToolbar"
      :loading="loading"
      :height="height"
      size="mini"
      resizable
      border
      :radio-config="{ highlight: true, trigger: 'row' }"
      :checkbox-config="{
        highlight: true,
        reserve: true,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:showName="{ row }">
        <span>{{ row.materialName }} {{ row.materialDisplayName }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <el-dialog
      v-if="visible"
      show-close
      visible
      width="450px"
      :title="'指定批次总箱数'"
      :close-on-click-modal="false"
      :before-close="() => () => (visible = false)"
      destroy-on-close
      append-to-body
    >
      <el-form ref="formData" :model="formData" :rules="rules" size="small">
        <el-row>
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.total_boxes_of_batch') || '批次总箱数'"
              prop="totBoxQty"
            >
              <el-input-number
                v-model="formData.totBoxQty"
                controls-position="right"
                size="small"
                style="width: 100%"
                :min="0"
                :step="1"
                :precision="0"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                readonly
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="() => (visible = false)">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="save()">
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </span>
    </el-dialog>
    <ChooseOrderGoodsDialog
      :title="$l('INDEX.choose_packing_goods') || '选择装箱方案产品'"
      ref="goodsDiaolog"
      :visible="goodsVisible"
      :data="data"
      @close="goodsVisible = false"
      @confirm="setData"
    />
  </div>
</template>
<script>
import tableColumns from './table-columns'
import validate from '@/libs/util.validate'
import ChooseOrderGoodsDialog from '../choose-order-goods/dialog.vue'

export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    height: { type: Number, default: 300 },
    type: { type: String, default: 'radio' },
  },
  components: {
    ChooseOrderGoodsDialog,
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: tableColumns(this),
      visible: false,
      goodsVisible: false,
      formData: { totBoxQty: '' },
      packingType: '',
      data: {},
      rules: {
        totBoxQty: [
          {
            required: true,
            message:
              this.$l('INDEX.please_input_batchBoxQty') || '请输入批次总箱数',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    choiceData() {
      this.data = this.getRadioRecord()
      if (!this.data) return
      if (this.data.packingType === 'B') {
        this.visible = true
      } else if (this.data.packingType === 'A') {
        this.$confirm(
          '<p>确认：&nbsp选择&nbsp<b>部分产品</b>&nbsp加入列表</p><p>取消：&nbsp默认&nbsp<b>全部产品</b>&nbsp加入列表</p>',
          '选择装箱方案产品',
          {
            confirmButtonText: this.$l('INDEX.btn_confirm') || '确认',
            cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true,
            closeOnClickModal: false,
            distinguishCancelAndClose: true,
          }
        )
          .then(() => {
            this.goodsVisible = true
          })
          .catch((action) => {
            if (action === 'cancel') {
              this.setData(this.data)
            }
          })
      }
    },
    getRadioRecord() {
      const data = this.$refs.vxeGrid.getRadioRecord()
      if (!data) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.table_label_pl_select_add_data') ||
            '请选择需要添加的数据',
          type: 'warning',
        })
        return
      }
      return data
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return false
      this.visible = false
      this.data.totBoxQty = this.formData.totBoxQty
      this.setData(this.data)
    },
    setData(res) {
      this.$emit('submit', res)
    },
  },
}
</script>
